import { Component, OnInit, QueryList, ContentChildren, HostListener, ElementRef } from '@angular/core';
import { ContextMenuOptionComponent } from './context-menu-option/context-menu-option.component';

let instances = 0;

@Component({
  selector: 'app-context-menu',
  templateUrl: './context-menu.component.html'
})
export class ContextMenuComponent implements OnInit {
  @ContentChildren(ContextMenuOptionComponent) options: QueryList<ContextMenuOptionComponent>;
  id: string;
  instance = 9999;
  isChecked = false;
  constructor(
    private eRef: ElementRef

  ) {
    ++instances;
    this.instance -= instances;
  }

  ngOnInit() {
    this.id = Math.random().toString(36).slice(-6);

  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isChecked = false;
    }
  }

}
